<template>
  <div class="card">
    <div class="card-header d-flex">
      <div>
        <p class="lead m-0 text-uppercase">{{'Sales' | translate}}</p>
      </div>
      <div class="ms-auto">
        <select class="form-control" v-model="range" @change="getData">
          <option value="7">7 {{ 'days' | translate }}</option>
          <option value="14">14 {{ 'days' | translate }}</option>
          <option value="30">30 {{ 'days' | translate }}</option>
          <option value="90">90 {{ 'days' | translate }}</option>
          <option value="365">365 {{ 'days' | translate }}</option>
        </select>
      </div>
    </div>
    <div class="card-body">
      <canvas style="heigth: 200px;" ref="transactions-chart"></canvas>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'

export default {
  props: ['page'],
  data() {
    return {
      mode: 'all',
      range: '7',
      latest: null,
      oldest: null,
      ctx: null,
      chart: null,
      options: {
        legend: {
          display: false,
          labels: {
            fontColor: '#cccccc',
          },
        },

        responsive: true,
        scales: {
          xAxes: [
            {
              type: 'time',
              distribution: 'linear',
              gridLines: {
                display: false,
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 5,
                maxRotation: 0,
              },
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'YY-MM-DD',
                  month: 'YY-MM',
                },
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store
        .dispatch('fetchDashboard', { range: this.range })
        .then((data) => {
          this.loading = false
        })
        .then((data) => {
          this.updateChart()
        })
    },
    setDates() {
      if (this.dateFormat === 'day') {
        this.options.scales.xAxes[0].ticks = {
          ...this.options.scales.xAxes[0].ticks,
          min: dayjs()
            .subtract(parseInt(this.range) + 1, 'days')
            .format(this.format),
          max: dayjs()
            .add(1, 'days')
            .format(this.format),
        }
      } else {
        this.options.scales.xAxes[0].ticks = {
          ...this.options.scales.xAxes[0].ticks,
          min: dayjs()
            .subtract(parseInt(this.range) + 1, 'days')
            .subtract(1, 'months')
            .format(this.format),
          max: dayjs()
            .add(1, 'days')
            .add(1, 'months')
            .format(this.format),
        }
      }
    },
    updateChart() {
      if (this.dateFormat === 'month') {
        this.options.scales.xAxes[0].time.unit = 'month'
      }
      if (this.dateFormat === 'day') {
        this.options.scales.xAxes[0].time.unit = 'day'
      }
      if (this.chart) {
        this.chart.destroy()
      }
      this.setDates()
      this.setupChart()
    },
    setMax() {
      let max = _.max(
        this.chartComputedData.map((dataset) => {
          let m = _.max(dataset.data, 'y')
          if (m && m.y) {
            return m.y
          }
        })
      )

      this.options.scales.yAxes[0].ticks.max = max + max * 0.166
    },
    setupChart() {
      this.ctx = this.$refs['transactions-chart']
      this.chart = new Chart(this.ctx, {
        type: 'bar',
        data: {
          datasets: this.chartComputedData,
        },
        options: this.options,
      })
    },
  },
  computed: {
    chartRawData() {
      return this.$store.state.dashboard.transactions
    },
    format() {
      if (this.dateFormat === 'month') {
        return 'YYYY-MM'
      }
      return 'YYYY-MM-DD'
    },
    dateFormat() {
      if (_.includes(['7', '14', '30'], this.range)) {
        return 'day'
      }
      return 'month'
    },
    chartComputedData() {
      let result = []

      for (const key in this.chartRawData) {
        if (this.chartRawData.hasOwnProperty(key)) {
          const element = this.chartRawData[key]

          const groupedTransactions = _.groupBy(element, (row) => {
            return dayjs(row.created_at).format(this.format)
          })

          const labels = Object.entries(groupedTransactions)

          if (
            (this.mode === 'single' && key === '') ||
            (this.mode === 'membership' && key === 'membership') ||
            this.mode === 'all'
          ) {
            result.push({
              label: this.$t(key || 'single'),
              data: labels.map((row) => {
                return {
                  x: row[0],
                  y: row[1].reduce((acc, current) => {
                    return acc + current.amount
                  }, 0) / 100 || 0,
                }
              }),
              borderWidth: 1,
              borderColor:
                key === 'membership'
                  ? 'rgba(255, 0, 156, .6)'
                  : 'rgba(77, 0, 174, .6)',
              backgroundColor:
                key === 'membership'
                  ? 'rgba(255, 0, 156, .2)'
                  : 'rgba(77, 0, 174, .2)',
            })
          }
        }
      }
      return result
    },
  },
}
</script>
